/*
  - To prevent users from seeing an incorrect cart when using back/forward browsers controls
  we detect the pageshow - and if it persists, it was loaded from cache, meaning the cart
  items may be incorrect - as long with other things. However, this is only made to solve
  the problem with the cart.

*/

/*
  - Send a custom event for us to catch else where. Made to have just 1 listener for pageshow
*/

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    console.warn("persisted");
    var evt = new CustomEvent("page:load:cache");
    document.body.dispatchEvent(evt); 
  }
});

window.addEventListener('resume', (event) => {
  if (event.persisted) {
    console.warn("persisted");
    var evt = new CustomEvent("page:load:cache");
    document.body.dispatchEvent(evt); 
  }
});

var cartCacheRefresh = () => {
  var cart = document.querySelector('cart-drawer');

  if (!cart) { return; }

  var randomParam = Math.round(Math.random() * 10000000);
  var renderURL = window.location.pathname + "?sections=cart-drawer,cart-icon-bubble&noCache=" + randomParam;

 fetch(`${renderURL}`)
    .then((response) => response.json())
    .then((response) => {
        var res = {
          sections: response
        }
        cart.renderContentsNoOpen(res);
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    });
}

console.warn(document, document.body);

document.body.addEventListener('page:load:cache', cartCacheRefresh);